import { StyleProp, TextStyle, View } from 'react-native'
import { VariantProp } from 'react-native-paper/lib/typescript/components/Typography/types'

import UniText from '@/components/unistyles/UniText'
import { isBold, stripMarkers } from '@/utils/strings'

const StyledSearchTitle = ({
  id,
  text,
  style,
  variant,
}: {
  id: string
  text: string
  style?: StyleProp<TextStyle>
  variant: VariantProp<typeof UniText>
}) => {
  return (
    <View key={id + '-styled-view'} style={{ flexDirection: 'row' }}>
      {text.split(' ').map((part, index) => (
        <UniText key={id + text + index}>
          <UniText
            style={{
              fontWeight: isBold(part) ? 'bold' : 'light',
              ...(typeof style === 'object' ? style : {}),
            }}
            variant={variant}
          >
            {stripMarkers(part)}
          </UniText>
          {index !== text.split(' ').length - 1 && (
            <UniText variant={variant}> </UniText>
          )}
        </UniText>
      ))}
    </View>
  )
}

export default StyledSearchTitle
